// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1JaB-","errorLogs":"styles_errorLogs__25rOw"};